export const shortDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two-digit month
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two-digit day
    const year = date.getFullYear(); // Full year

    return `${month}/${day}/${year}`;
};
